import React, { useContext } from "react";
import { Row, Col } from "react-bootstrap";
import {
  faShieldAlt,
  faWater,
  faCertificate,
  faTint,
  faMoneyBill,
  faClipboardList,
  faFileCsv,
  faTabletAlt,
  faFile,
  faGlobeAmericas,
  faPencilRuler,
  faGripLines,
  faLaptopCode
} from "@fortawesome/free-solid-svg-icons";
import { UserContext } from "../reuseableComponents/auth/UserContext";
import MenuCard from "../reuseableComponents/MenuCard";

/*The keys in the menuIcon object are the same names that should be getting passed into the
GET_APP_MENU query on each of the respective menu pages*/

const menuIcons = {
  BF: faWater,
  CERTS: faCertificate,
  ENG: faFileCsv,
  FILE_UPLD: faFile,
  LT: faMoneyBill,
  LSL: faGripLines,
  PRTL: faTabletAlt,
  RAE: faShieldAlt,
  SP: faTint,
  SV: faClipboardList,
  SWR: faGlobeAmericas,
  IPS: faPencilRuler,
  ADMIN: faLaptopCode
};

const StaffIndex = () => {
  const { user } = useContext(UserContext);
  return (
    <>
      {user.assignments ? (
        <Row>
          {user.assignments.map((module) => (
            <Col md={4} key={module.moduleCode}>
              <MenuCard
                icon={menuIcons[module.moduleCode]}
                module={module.moduleCode}
                route={module.moduleRoute}
                name={module.moduleAssigned}
              />
            </Col>
          ))}
        </Row>
      ) : (
        <Row>
          <Col>
            <span>You have not yet been granted access to any modules.</span>
          </Col>
        </Row>
      )}
    </>
  );
};

export default StaffIndex;
